// extracted by mini-css-extract-plugin
export var calendarView = "_ov-0";
export var dayButton = "_ov-1";
export var dayCircle = "_ov-2";